// Filter.tsx

import { Box, Checkbox, FormControlLabel, FormGroup, Tooltip } from '@mui/material';

interface TooltipData {
  dimensions_for_sizes: {
    [sizeName: string]: {
      diameter?: string[];
      height?: string[];
      item_height?: string[];
      item_length?: string[];
      length_cm?: string[];
      width?: string[];
    };
  };
}

interface FilterProps {
  // Now filterType is always a string array in the new structure
  filterType: string[];

  // Add this prop to match what FilterSelection is passing
  filteredOptions?: string[];

  handleCheckboxChange: (
    elem: string,
    setList: React.Dispatch<React.SetStateAction<string[]>>,
    list: string[],
    paramKey: string
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;

  list: string[];
  setList: React.Dispatch<React.SetStateAction<string[]>>;
  keyName: string;
  paramKey: string;
  tooltipData?: TooltipData | null;
  itemGroup?: string;
  applicationsList?: string[];
}

const Filter = ({
                  filterType,
                  filteredOptions,
                  handleCheckboxChange,
                  list,
                  setList,
                  keyName,
                  paramKey,
                  tooltipData = null,
                  itemGroup = '',
                  applicationsList = []
                }: FilterProps) => {

  // Helper function to generate tooltip content
  const getTooltipContent = (sizeName: string): string => {
    if (!tooltipData?.dimensions_for_sizes?.[sizeName]) {
      return '';
    }

    const dimensions = tooltipData.dimensions_for_sizes[sizeName];
    const parts: string[] = [];

    if (dimensions.diameter?.length) {
      parts.push(`Diameter: ${dimensions.diameter.join(', ')}`);
    }
    if (dimensions.height?.length) {
      parts.push(`Height: ${dimensions.height.join(', ')}`);
    }
    if (dimensions.item_height?.length) {
      parts.push(`Item Height: ${dimensions.item_height.join(', ')}`);
    }
    if (dimensions.item_length?.length) {
      parts.push(`Item Length: ${dimensions.item_length.join(', ')}`);
    }
    if (dimensions.length_cm?.length) {
      parts.push(`Length: ${dimensions.length_cm.join(', ')}`);
    }
    if (dimensions.width?.length) {
      parts.push(`Width: ${dimensions.width.join(', ')}`);
    }

    return parts.join(' | ');
  };

  return (
    <Box>
      <FormGroup>
        {filterType
          .slice()
          .sort((a, b) => a.localeCompare(b))
          .map((elem) => {
            // With the new structure, all elements are strings
            const label = elem;
            const value = elem;
            const isChecked = list.includes(value);

            // Check if tooltips should be shown for this item
            const tooltipContent = tooltipData ? getTooltipContent(elem) : '';
            const showTooltip = !!tooltipContent;

            const checkboxControl = (
              <FormControlLabel
                key={elem}
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={handleCheckboxChange(
                      value,
                      setList,
                      list,
                      paramKey
                    )}
                  />
                }
                label={label}
              />
            );

            // Wrap in Tooltip if we have tooltip content
            if (showTooltip) {
              return (
                <Tooltip
                  key={elem}
                  title={tooltipContent}
                  arrow
                  placement="right"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#333',
                        color: '#fff',
                        fontSize: '12px',
                        padding: '8px 12px',
                        maxWidth: '300px'
                      }
                    },
                    arrow: {
                      sx: {
                        color: '#333'
                      }
                    }
                  }}
                >
                  {checkboxControl}
                </Tooltip>
              );
            }

            // Return without tooltip if no tooltip data
            return checkboxControl;
          })}
      </FormGroup>
    </Box>
  );
};

export default Filter;